<template>
  <div class="container container--large">
    <div class="row">
      <div class="col-xs-12 promo-header">
        If you'd like, please select from the following package deals below.
        Then click "Proceed to General Membership List" to make individual
        selections, or click "Proceed to Checkout" to skip the individual
        selections option.
      </div>
      <div
        v-for="item in promotions"
        :key="item.id"
        class="promo-wrap col-md-4"
      >
        <md-checkbox
          v-model="item.value"
          :disabled="item.paid || item.disabled"
          @change="
            onPromoChange(item);
            onPromoChangeUpdate(item);
          "
          >{{ item.displayText }}</md-checkbox
        >
      </div>
    </div>
    <div class="row">
      <div class="col btn-wrap">
        <md-button
          class="btn-blue"
          @click="
            nextPage = 'general';
            savePromotions(promotions);
          "
          >Proceed To General Membership List</md-button
        >
        <md-button
          class="btn-green"
          @click="
            nextPage = 'checkout';
            savePromotions(promotions);
          "
          >Proceed To Checkout</md-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import currencyFilter from "../shared/currency-filter";
import { showErrorAlert } from "../helpers";

export default {
  name: "PromotionScreenPage",
  filters: {
    currency: currencyFilter,
  },
  data: function() {
    return {
      nextPage: "general",
      promotions: [],
    };
  },
  computed: {
    customOptions() {
      return this.$store.state.customOptions;
    },
    organization() {
      return this.$store.state.organizationInfo;
    },
    cart() {
      return this.$store.state.cart;
    },
    order() {
      return this.$store.state.finalOrder;
    },
    discounts() {
      return this.$store.state.discounts;
    },
    async getPromotions() {
      try {
        let data = this.$store.state.promotions;
        let prop = "sortOrder";
        data = data.sort(function(a, b) {
          return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0;
        });
        console.log("promotions ", data);
        let f_promo = data.filter(
          (a) =>
            !a.paid &&
            a.value &&
            (a.allCategories.indexOf("all") > -1 ||
              a.allCategories.indexOf("All") > -1 ||
              a.allCategories.indexOf("ALL") > -1)
        );
        if (f_promo.length) {
          console.log("f_promo ", f_promo);
          for (let i = 0; i < data.length; i++) {
            if (
              data[i].allCategories.length &&
              data[i].itemId !== f_promo[0].itemId &&
              !data[i].paid
            ) {
              if (data[i].value) {
                let obj = {
                  itemId: data[i].itemId,
                  price: data[i]?.price,
                  quantity: 1,
                  description: data[i].displayText,
                  shipTo: "",
                  message: "",
                };
                await this.$store.dispatch("updateUpsell", {
                  data: obj,
                  param: "delete",
                });
              }
              data[i].value = false;
              data[i].disabled = true;
            }
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            if (!data[i].paid) {
              data[i].disabled = false;
            }
          }
        }

        return data;
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    filteredData() {
      return this.$store.state.list;
    },
  },

  async mounted() {
    try {
      this.promotions = await this.getPromotions;
    } catch (error) {
      console.error(error);
      showErrorAlert(true);
    }
  },
  methods: {
    async onPromoChange(item) {
      // this function is for checking of all promotion is selected and disable others that have no categories
      // console.log("promo ", item, "promotions ", this.promotions);
      try {
        if (
          item.allCategories.indexOf("all") > -1 ||
          item.allCategories.indexOf("ALL") > -1 ||
          item.allCategories.indexOf("All") > -1
        ) {
          if (item.value) {
            for (let i = 0; i < this.promotions.length; i++) {
              if (
                this.promotions[i].allCategories.length &&
                this.promotions[i].itemId !== item.itemId
              ) {
                if (this.promotions[i].value && !this.promotions[i].paid) {
                  let obj = {
                    itemId: this.promotions[i].itemId,
                    price: this.promotions[i]?.price,
                    quantity: 1,
                    description: this.promotions[i].displayText,
                    shipTo: "",
                    message: "",
                  };
                  await this.$store.dispatch("updateUpsell", {
                    data: obj,
                    param: "delete",
                  });
                }
                this.promotions[i].value = false;
                this.promotions[i].disabled = true;
              }
            }
          } else {
            for (let i = 0; i < this.promotions.length; i++) {
              this.promotions[i].disabled = false;
            }
          }
        } else {
          let f_promo = this.promotions.filter(
            (a) =>
              !a.paid &&
              a.value &&
              (a.allCategories.indexOf("all") > -1 ||
                a.allCategories.indexOf("All") > -1 ||
                a.allCategories.indexOf("ALL") > -1)
          );

          for (let i = 0; i < this.promotions.length; i++) {
            if (
              this.promotions[i].allCategories.length &&
              !this.promotions[i].paid &&
              !f_promo.length
            ) {
              this.promotions[i].disabled = false;
            }
          }
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    async onPromoChangeUpdate(item) {
      let obj = {
        itemId: item.itemId,
        price: item?.price,
        quantity: 1,
        description: item.displayText,
        shipTo: "",
        message: "",
      };
      if (item.value && !item.paid) {
        await this.$store.dispatch("updateUpsell", { data: obj, param: "add" });

        // this.$store.commit("updateListInPromotions", combo);
        if (item.allCategories.length) {
          for (let z = 0; z < item.allCategories.length; z++) {
            for (let k = 0; k < this.filteredData.length; k++) {
              //  if promotions categories have more than all category, loop through member categries and check if exsist,  select
              if (
                !this.filteredData[k].paid &&
                this.filteredData[k].mCategories.indexOf(
                  Number(item.allCategories[z])
                ) > -1
              ) {
                this.filteredData[k].selected = true;
              }
            }
          }
        }
      } else {
        await this.$store.dispatch("updateUpsell", {
          data: obj,
          param: "delete",
        });

        if (item.allCategories.length) {
          for (let z = 0; z < item.allCategories.length; z++) {
            if (item.allCategories[z].toLowerCase() === "all") {
              for (let k = 0; k < this.filteredData.length; k++) {
                if (!this.filteredData[k].paid) {
                  this.filteredData[k].selected = false;
                }
              }
            } else {
              for (let k = 0; k < this.filteredData.length; k++) {
                //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes de select
                if (
                  !this.filteredData[k].paid &&
                  this.filteredData[k].mCategories.indexOf(
                    Number(item.allCategories[z])
                  ) > -1
                ) {
                  this.filteredData[k].selected = false;
                }
              }
            }
          }
        }
      }
    },
    checkIfOnePromoSelected: function(promos) {
      let selected = false;
      for (var i = 0; i < promos.length; i++) {
        if (promos[i].value && !promos[i].paid) {
          selected = true;
          return selected;
        }
      }
      return selected;
    },
    savePromotions: function(promo, save) {
      for (let z = 0; z < this.filteredData.length; z++) {
        if (!this.filteredData[z].paid) {
          // this.filteredData[z].selected = false;
        }
      }
      let parsedpromo = JSON.parse(JSON.stringify(promo));
      // console.log("parsedpromo", parsedpromo, save);
      if (this.checkIfOnePromoSelected(parsedpromo)) {
        let combo = [];
        //   lets uncheck people first
        let false_promos = [];
        // for (let i = 0; i < parsedpromo.length; i++) {
        //   if (!parsedpromo[i].value && parsedpromo[i].allCategories.length) {
        //     for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
        //       for (let k = 0; k < this.filteredData.length; k++) {
        //         //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes select
        //         if (
        //           !this.filteredData[k].paid &&
        //           this.filteredData[k].mCategories.indexOf(
        //             Number(parsedpromo[i].allCategories[z])
        //           ) !== -1
        //         ) {
        //           this.filteredData[k].selected = false;
        //         }
        //       }
        //     }
        //   }
        // }

        //  if checked and  select based on categories
        for (let i = 0; i < parsedpromo.length; i++) {
          let promo_obj = {
            promo: {},
            ids: [],
            members: [],
          };
          let obj = {
            itemId: parsedpromo[i].itemId,
            price: parsedpromo[i]?.price,
            quantity: 1,
            description: parsedpromo[i].displayText,
            shipTo: "",
            message: "",
          };

          if (parsedpromo[i].allCategories.length && parsedpromo[i].value) {
            promo_obj.promo = parsedpromo[i];
            for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
              if (
                parsedpromo[i].allCategories[z].toLowerCase() === "all" &&
                parsedpromo[i].value
              ) {
                //  if all category is select , select all pplz
                for (let d = 0; d < this.filteredData.length; d++) {
                  if (!this.filteredData[d].paid) {
                    this.filteredData[d].selected = true;
                    if (promo_obj.ids.indexOf(this.filteredData[d].id) === -1) {
                      promo_obj.ids.push(this.filteredData[d].id);
                      promo_obj.members.push(this.filteredData[d]);
                    }
                  }
                }
                combo.push(promo_obj);
              } else {
                for (let k = 0; k < this.filteredData.length; k++) {
                  //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes select
                  if (
                    !this.filteredData[k].paid &&
                    this.filteredData[k].mCategories.indexOf(
                      Number(parsedpromo[i].allCategories[z])
                    ) !== -1
                  ) {
                    this.filteredData[k].selected = true;
                    if (promo_obj.ids.indexOf(this.filteredData[k].id) === -1) {
                      promo_obj.ids.push(this.filteredData[k].id);
                      promo_obj.members.push(this.filteredData[k]);
                    }
                  }
                }
                let f = combo.filter((a) => a.promo.id === promo_obj.promo.id);
                if (!f.length) {
                  combo.push(promo_obj);
                }
              }
            }
          }
          // if send to all option selected
          // console.log("parsed promo i ", parsedpromo[i], parsedpromo[i].value);
          if (parsedpromo[i].value && !parsedpromo[i].paid) {
            //this.$store.dispatch("updateUpsell", { data: obj, param: "add" });
            this.$store.commit("updateListInPromotions", combo);
          }
          // else {
          //   this.$store.dispatch("updateUpsell", {
          //     data: obj,
          //     param: "delete",
          //   });
          // }
        }
      } else {
        this.$store.commit("updateListInPromotions", []);
      }

      //! WARNING TODO:
      this.saveList(this.filteredData).then();
      // this.saveList([]).then();
      ////console.log("promo combo ", combo);
    },
    checkIfAllPaid: function(list) {
      let check = true;
      for (let i = 0; i < list.length; i++) {
        if (!list[i].paid) {
          check = false;
          return check;
        }
      }
      return check;
    },
    saveList: async function(list) {
      let allpaid = this.checkIfAllPaid(list);
      let parsedlist = JSON.parse(JSON.stringify(list));
      let checked_list = parsedlist.filter((a) => a.selected && !a.paid);
      let unchecked_list = parsedlist.filter((a) => !a.selected && !a.paid);

      // let promo_list = parsedpromo.filter((a) => a.value);
      this.$store.commit("addListToCart", checked_list);
      // for (let i = 0; i < promo_list.length; i++) {
      //   this.$store.commit("addToCart", promo_list[i]);
      // }
      let checked_arr = [];
      for (let i = 0; i < checked_list.length; i++) {
        let item = {};
        item.tempcode = this.$store.state.tempCode;
        item.receiver = checked_list[i].id;
        if (
          !this.$store.state.shippingCustomOptions.length ||
          this.customOptions.noShipCustom.indexOf(this.organization[0].id) > -1
        ) {
          item.price = checked_list[i]?.price;
        } else {
          let ship = this.$store.state.shippingCustomOptions.filter(
            (a) => a.description === checked_list[i].basketType
          );

          if (ship) {
            item.price = ship[0]?.price;
            item.customPrice = ship[0]?.price;
          } else {
            item.price = 0;
            item.customPrice = 0;
          }
        }
        checked_arr.push(item);
      }
      let unchecked_arr = [];
      for (let i = 0; i < unchecked_list.length; i++) {
        let item = {};
        item.tempCode = this.$store.state.tempcode;
        item.receiver = unchecked_list[i].id;
        item.price = unchecked_list[i]?.price;
        unchecked_arr.push(item);
      }

      console.log(checked_list, this.$store.state.cart, checked_arr);

      if (checked_arr.length) {
        if (this.nextPage === "checkout") {
        await  this.$store.dispatch("updateData", {
            data: checked_arr,
            param: "add",
            redirect: true,
          });
          this.$store.state.checked_arr = checked_arr;
        } else {
          this.$store.state.listChanged = true;
          this.$router.push("/content/list").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        }
      }
      if (unchecked_arr.length) {
        {
          if (this.nextPage !== "checkout") {
            this.$router.push("/content/list").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          } else {
            this.$router.push("/content/promo").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }
        }
        // this.$store.dispatch("updateData",{data:unchecked_arr, param:'delete'})
      }
      if (allpaid) {
        if (this.nextPage !== "checkout") {
          this.$router.push("/content/list").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        } else {
          this.$router.push("/content/promo").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        }
      }
      // if (this.nextPage === "checkout") {
      //   this.$router.push("/content/promo").catch((error) => {
      //     if (error.name != "NavigationDuplicated") {
      //       throw error;
      //     }
      //   });
      // } else {
      //   this.$router.push("/content/list").catch((error) => {
      //     if (error.name != "NavigationDuplicated") {
      //       throw error;
      //     }
      //   });
      // }
    },
    // async saveList(list) {
    //   let allpaid = this.checkIfAllPaid(list);
    //   let parsedlist = JSON.parse(JSON.stringify(list));
    //   let checked_list = parsedlist.filter((a) => a.selected && !a.paid);
    //   let unchecked_list = parsedlist.filter((a) => !a.selected && !a.paid);

    //   // let promo_list = parsedpromo.filter((a) => a.value);
    //   this.$store.commit("addListToCart", parsedlist);
    //   // for (let i = 0; i < promo_list.length; i++) {
    //   //   this.$store.commit("addToCart", promo_list[i]);
    //   // }

    //   console.log("-=--=- all checked list -=-=----", checked_list);

    //   let checked_arr = [];
    //   for (let i = 0; i < checked_list.length; i++) {
    //     console.log("-=-=-=- checked_list[i] -=----- ", checked_list[i]);

    //     let item = {
    //       price: 0,
    //     };
    //     item.tempcode = this.$store.state.tempCode;
    //     item.receiver = checked_list[i].id;
    //     if (
    //       !this.$store.state.shippingCustomOptions.length ||
    //       this.customOptions.noShipCustom.indexOf(this.organization[0].id) > -1
    //     ) {
    //       console.log("item.price = checked_list[i].price; FIRST BEFORE");
    //       item.price = checked_list[i]?.price;
    //       console.log("item.price = checked_list[i].price; FIRST");
    //     } else {
    //       //! WARNING TODO:

    //       let ship = this.$store.state.shippingCustomOptions.filter((a) => {
    //         console.log("-=-=-=- shp custom", {
    //           inStore: a.description,
    //           checked_list: checked_list[i].basketType,
    //           allChecked: checked_list,
    //         });
    //         return a.description === checked_list[i].basketType;
    //       });
    //       console.log("item.price = ship[0].price; ELSE BEFORE", ship);
    //       if (ship) {
    //         item.price = ship[0]?.price;
    //         item.customPrice = ship[0]?.price;
    //       } else {
    //         item.price = 0;
    //         item.customPrice = 0;
    //       }
    //     }
    //     checked_arr.push(item);
    //   }
    //   let unchecked_arr = [];
    //   for (let i = 0; i < unchecked_list.length; i++) {
    //     let item = {};
    //     item.tempCode = this.$store.state.tempcode;
    //     item.receiver = unchecked_list[i].id;
    //     item.price = unchecked_list[i]?.price;
    //     console.log("item.price = unchecked_list[i].price;");
    //     unchecked_arr.push(item);
    //   }

    //   console.log(checked_list, this.$store.state.cart, checked_arr);

    //   if (checked_arr.length) {
    //     if (this.nextPage === "checkout") {
    //       await this.$store.dispatch("updateData", {
    //         data: checked_arr,
    //         param: "add",
    //         redirect: true,
    //       });
    //       this.$store.state.checked_arr = checked_arr;
    //     } else {
    //       this.$store.state.listChanged = true;
    //       this.$router.push("/content/list").catch((error) => {
    //         if (error.name != "NavigationDuplicated") {
    //           throw error;
    //         }
    //       });
    //     }
    //   }
    //   if (unchecked_arr.length) {
    //     {
    //       if (this.nextPage !== "checkout") {
    //         this.$router.push("/content/list").catch((error) => {
    //           if (error.name != "NavigationDuplicated") {
    //             throw error;
    //           }
    //         });
    //       } else {
    //         this.$router.push("/content/promo").catch((error) => {
    //           if (error.name != "NavigationDuplicated") {
    //             throw error;
    //           }
    //         });
    //       }
    //     }
    //     // this.$store.dispatch("updateData",{data:unchecked_arr, param:'delete'})
    //   }
    //   if (allpaid) {
    //     if (this.nextPage !== "checkout") {
    //       this.$router.push("/content/list").catch((error) => {
    //         if (error.name != "NavigationDuplicated") {
    //           throw error;
    //         }
    //       });
    //     } else {
    //       this.$router.push("/content/promo").catch((error) => {
    //         if (error.name != "NavigationDuplicated") {
    //           throw error;
    //         }
    //       });
    //     }
    //   }
    //   // if (this.nextPage === "checkout") {
    //   //   this.$router.push("/content/promo").catch((error) => {
    //   //     if (error.name != "NavigationDuplicated") {
    //   //       throw error;
    //   //     }
    //   //   });
    //   // } else {
    //   //   this.$router.push("/content/list").catch((error) => {
    //   //     if (error.name != "NavigationDuplicated") {
    //   //       throw error;
    //   //     }
    //   //   });
    //   // }
    // },
  },
};
</script>
<style scoped>
.promo-header {
  margin: 2em 0 2em;
  font-size: 23px;
  line-height: 40px;
  background: #ff607f;
  padding: 1em;
  color: white;
}
.btn-wrap {
  padding: 1em;
  text-align: center;
  margin-top: 1em;
}
</style>
